import axios from 'axios';
import './api_helper';
import { api } from '../config';

const BASE = api.API_URL;

export const getProyectosKpis = (empresaId, year) =>
    axios.get(`${BASE}/proyectos/kpis`, { params: { empresa_id: empresaId, year } });

export const getProyectosEvolucion = (empresaId, year) =>
    axios.get(`${BASE}/proyectos/evolucion-mensual`, { params: { empresa_id: empresaId, year } });
export const getProyectosMediaEvolucion = (empresaId, year) =>
    axios.get(`${BASE}/proyectos/media-evolucion`, { params: { empresa_id: empresaId, year } });
export const getProyectosRendimiento = (empresaId, filtroParcial, segmento) =>
    axios.get(`${BASE}/proyectos/rendimiento`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
            segmento,
        }
    });

export const getProyectosPorTipo = (empresaId, year) =>
    axios.get(`${BASE}/proyectos/por-tipo`, { params: { empresa_id: empresaId, year } });

export const getProyectosPorPais = (empresaId, year) =>
    axios.get(`${BASE}/proyectos/por-pais`, { params: { empresa_id: empresaId, year } });

export const getProyectosTareasPendientes = (empresaId) =>
    axios.get(`${BASE}/proyectos/tareas-pendientes`, { params: { empresa_id: empresaId } });

export const getProyectosParcial = (empresaId, filtroParcial, segmento) =>
    axios.get(`${BASE}/proyectos/parcial`, {
        params: {
            empresa_id: empresaId,
            periodo: filtroParcial?.preset,
            date_from: filtroParcial?.from,
            date_to: filtroParcial?.to,
            segmento,
        }
    });
